<template>
  <div class="basic_wrap">
    <div class="red_top_bg">
      <div
        class="back_left"
        @click="$router.back()"
      />
      <div class="big_tit">
        {{ $t('shopd.oprogress') }}
      </div>
      <!-- <div class="top_right" @click="$router.push('/moneybag')">
				<van-icon name="bars" size="25"/>
			</div> -->
    </div>
    <!-- <div class="status">{{$t('shopd.oprogress')}}</div> -->
    <div
      v-if="data"
      class="box goods"
    >
      <div class="header1">
        <svg
          class="icon"
          viewBox="0 0 1024 1024"
          width="18"
          height="18"
        >
          <path
            d="M952.832 352.768c-0.064-0.48-0.16-0.928-0.256-1.312-0.384-1.856-0.896-3.648-1.632-5.376L875.936 159.36c-12.96-38.592-48.832-62.56-93.952-62.56L255.488 96.8c-44.224 0-78.592 23.52-91.04 60.704l-80.64 190.528c-0.384 1.12-0.8 2.784-1.152 4.48-5.856 17.984-8.8 36.448-8.8 54.976 0.064 65.184 35.84 124.704 93.28 155.264 23.648 12.672 51.52 19.072 82.816 19.072 0.032 0 0.064 0 0.096 0 52.512-0.128 101.152-23.2 134.304-62.688 32.992 39.136 81.248 62.08 133.664 62.4 52-0.384 100.096-23.424 132.96-62.56 33.152 39.488 81.856 62.496 134.624 62.496 31.936-0.192 60.288-6.88 84.16-20 56.576-30.88 91.68-90.176 91.648-154.656C961.44 388.256 958.4 369.696 952.832 352.768zM766.432 383.968 254.4 383.968c-17.664 0-32-14.336-32-32s14.336-32 32-32l512.032 0c17.696 0 32 14.336 32 32S784.128 383.968 766.432 383.968z"
            p-id="2387"
            fill="#ffffff"
          />
          <path
            d="M895.072 640c0-17.696-14.304-32-32-32-3.296 0-6.272 0.928-9.248 1.888l0 0c-23.712 9.376-54.048 14.432-76.928 13.184-50.432-2.688-88.864-12.736-125.888-44.256-36.512 31.136-83.104 48.864-132.704 49.312-50.304-0.32-97.152-12.928-133.856-44.128-36.928 31.488-84.064 46.816-134.272 46.816L249.984 630.816c-30.656 0-47.936-5.824-75.84-16.128-0.768-0.384-1.568-0.576-2.368-0.864-1.344-0.512-2.368-0.864-3.744-1.376 0 0-4.608-0.8-7.136-0.8 0 0-0.032 0-0.064 0-17.664 0-31.968 14.368-31.936 32.064l0.224 171.488c0 45.12 36.768 81.824 81.984 81.824l602.176-0.384c45.152-0.128 81.888-36.928 81.888-82.048L895.072 640z"
            fill="#ffffff"
          />
        </svg>
        <span style="overflow: hidden;height: 5vh;display: block;">{{ data.title }}</span>
      </div>
      <div class="content">
        <div class="left">
          <img :src="data.pic">
        </div>
        <div class="right">
          <div class="title">
            {{ data.title }}
          </div>
          <div class="price-number">
            <div class="price">
              $ {{ data.price }}
            </div>
            <div class="number">
              x1
            </div>
          </div>
          <div class="earnings">
            {{ $t('shopd.commission') }}: <em>$ {{ data.fee }}</em>
          </div>
          <!-- <div>Commission: $ {{data.fee}}</div> -->
        </div>
      </div>
    </div>
    <div
      id="submit_button"
      class="button submit"
      @click="doorder()"
    >
      {{ $t('shopd.completeorder') }}
    </div>
  </div>
</template>

<script>
	import Vue from "vue";
	import {
		Empty
	} from "vant";
    var _that;
	import {
		Dialog
	} from 'vant';
	import Fetch from "../../utils/fetch";
	Vue.use(Empty);
	export default {
		name: "Odetail",
		data() {
			return {
				lang: this.$i18n.locale || "zh_cn",
				data: null
			};
		},
		created() {
			this.$parent.footer("ordering");
		},
		mounted() {
			this.start();
			_that = this;
		},
		methods: {
			start() {
				Fetch("/user/ordering").then((r) => {
					this.data = r.data;
				});
			},
			doorder(){
				Fetch("/user/doorder", {
				  id: this.data.id
				}).then(r => {
					// showDialog({
					//   message: this.$t('shopd.corder'),
					//   theme: 'round-button',
					// }).then(() => {
					//   this.$router.push('/grap');
					// });
					this.$toast({
						duration:'3000',
						background: '#07c160',
						message: this.$t('shopd.corder')
					});
					this.$router.push('/grap');
				}).catch(err=>{
					if(err && err.code==0 && err.data && err.data.need){
						Dialog.confirm({
							title: 'Tips',
							confirmButtonText:this.$t('moneybag.recharge'),
							cancelButtonText:this.$t('shopd.cancelbtn'),
							message: this.$t('c3.need') + " " +this.utils_moneyMark()+ err.data.need.toFixed(2)
						})
						.then(() => {
						  this.$router.push('/invest');
						})
						.catch(() => {
						});
						
					}
				})
			}
		},
	};
</script>

<style lang="less" scoped>
	.red_top_bg {
		
	}

	.money_box {
		display: flex;
		justify-content: space-around;
		border-radius: 10px;
		padding: 10px;
		margin: 10px;
		color:#36333d;
		background: #FFF;

		.item {
			width: 33.33%;
			text-align: center;
			font-weight: bold;

			.money_num {
				font-size: 18px;
				line-height: 25px;
				white-space: normal;
				word-break: normal;
				text-align: center;
			}

			.info {
				font-size: 12px;
				line-height: 20px;
				font-weight: normal;
				margin-top: 5px;
			}
		}
	}

	.notes_tit {
		line-height: 44px;
		height: 44px;
		font-size: 14px;
		color: #000000;
		padding: 0 14px;
		background: #FAFAFA;
		z-index: 2;
		margin: 10px;
		border-radius: 5px;
	}

	.notes_box {
		width: 100%;
		padding-bottom: 2px;
		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 2px 9px 2px rgba(160, 160, 160, 0.15);
		border-radius: 6px;
		margin-bottom: 10px;

		.timer {
			padding: 3px 3px;
			font-size: 12px;
			color: rgba(0, 0, 0, .6);
			border-bottom: 1px solid #ececec;
			display: flex;
			justify-content: space-between;
			align-items: center;

			span {
				font-style: normal;
				padding: 5px;
				border-radius: 5px;
				color: #FFFFFF;
			}

			.ing {
				background: #3775f4;
			}

			.finish {
				font-style: normal;
				background: #07c160;
			}
		}

		.item_div1 {
			display: flex;
			justify-content: space-between;
			padding: 15px 10px;

			p:nth-child(1) {
				width: 100%;
				font-weight: bold;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;

			}
		}

		.item_div2 {
			display: flex;
			justify-content: space-between;
			text-align: center;
			margin-bottom: 5px;
			margin-top: 5px;
			div {
				width: 33.33%;

				p {
					padding: 5px 0;
				}
			}

			.item_rate {
				p:nth-child(1) {
					font-weight: bold;
					font-size: 14px;
					color: #FF0000;

				}

				p:nth-child(2) {
					color: #999;
				}
			}

			.item_day {
				p:nth-child(1) {
					font-weight: bold;
					font-size: 14px;

				}

				p:nth-child(2) {
					color: #999;
				}
			}

			.item_min {
				p:nth-child(1) {
					font-weight: bold;
					font-size: 14px;

				}

				p:nth-child(2) {
					color: #999;
				}
			}
		}
	}

	.scrollBox {
		width: 96%;
		margin-left: 2%;
	}
	
	.head-tabs {
	    height: 50px;
	    padding: 15px;
	    background: #fff;
	    white-space: nowrap;
		border-radius: 10px;
		margin: 10px;
		.tab-item {
		    z-index: 0;
		    position: relative;
		    height: 16px;
		    line-height: 16px;
		    font-size: 14px;
		    color: #ababab;
		    transition: all .3s ease;
		}
		.tab-item:after {
		    z-index: -1;
		    content: "";
		    position: absolute;
		    left: 0;
		    right: 0;
		    bottom: 0;
		    height: 4px;
		    border-radius: 2px;
			
		}
		.active {
		    font-size: 1.5em;
		    color: #282828;
			:after {
			    background: #ff8c46;
			}
		}
		.tab-item.active:after {
		    background: #ff8c46;
		}
		.tab-item+.tab-item {
		    margin-left: 20px;
		}
	}
	.box {
		margin: 3vw;
		border-radius: 2vw;
		overflow: hidden;
	    background-color: rgb(12, 109, 86);
		padding: 0;
		color: #FFF;
		.header1 {
			position: relative;
			padding: 0 10px 0 34px;
			height: 40px;
			line-height: 40px;
			font-size: 14px;
			font-weight: bold;
			color: #fff;
			background: linear-gradient(180deg, #36333d, #746b0a);
			background: #ee264d;;
			 .icon {
			    position: absolute;
			    left: 10px;
			    top: 11px;
			}
			.id {
			    font-weight: bold;
				color: #FFF;
			}
			.time {
			    flex: 1;
			    text-align: right;
			    color: #999;
			    font-size: 10px;
				color: #FFF;
			}
		}
		.button {
		    display: block;
		    padding: 0 10px;
		    border-radius: 5px;
		    height: 40px;
		    line-height: 40px;
		    font-size: 18px;
		    color: #202226;
		    text-align: center;
		    background: linear-gradient(180deg, #36333d, #746b0a);
		    overflow: hidden;
		    cursor: pointer;
		}
		.content {
		    display: flex;
		    padding: 10px;
			.left {
				border-radius: 5px;
				width: 90px;
				height: 90px;
				padding: 2px;
				text-align: center;
				background-color: #75777a;
				overflow: hidden;
				img {
				    border-radius: 3vw;
				    width: 90px;
				    height: 90px;
				}
			}
			.right {
			    flex: 1;
				padding-left: 10px;
				line-height: 20px;
				.title {
					margin-bottom: 10px;
					height: 20px;
					font-weight: 500;
					overflow: hidden;
				}
				 .price,.earnings {
				    color: #aaa;
					 em {
						font-style: normal;
						font-size: 16px;
						font-weight: bold;
						color: #e5ae2f;
					}
				}
				.price-number {
				    display: flex;
				    margin-top: 10px;
					.price {
					    color: #e5ae2f;
					    font-size: 16px;
					    font-weight: bold;
					}
					.number {
					    flex: 1;
					    color: #999;
					    text-align: right;
					}
				}
			}
			.button {
			    display: block;
			    padding: 0 10px;
			    border-radius: 5px;
			    height: 40px;
			    line-height: 40px;
			    font-size: 18px;
			    color: #202226;
			    text-align: center;
			    background: linear-gradient(180deg, #36333d, #746b0a);
			    overflow: hidden;
			    cursor: pointer;
			}
		}
	}
	.status {
	    margin-top: 10px;
	    border-bottom: 1px solid #707070;
	    height: 50px;
	    line-height: 50px;
	    color: #ffffff;
	    font-size: 16px;
	    text-align: center;
	}
	.button {
	    display: block;
	    padding: 0 10px;
	    border-radius: 5px;
	    height: 40px;
	    line-height: 40px;
	    font-size: 16px;
	    color: #FFF;
	    text-align: center;
	    background: linear-gradient(180deg, #36333d, #746b0a);
		background: linear-gradient(180deg, #36333d, #746b0a);
	    overflow: hidden;
	    cursor: pointer;
	}
	.submit {
	    margin: 30px 10vw;
	}
	.goods {
	    padding: 0;
	    background-color: rgb(12, 109, 86);
	}
</style>
